import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, Subscriber} from 'rxjs';
import {map} from 'rxjs/operators';
import {ApiLocationService} from '@services/api-location/api-location.service';
import {MachineGroup} from '@models/adminstration/machine-group/machine-group';
import {Machine} from '@models/machine/machine';
import {HTTPS_REQUEST_OPTIONS} from '@constants/https-request-options/https-request-options';
import {MachineryGroupPayload} from '@models/adminstration/machine-group/machinery-group-payload';

@Injectable({
  providedIn: 'root'
})
export class MachineGroupService {


  private MACHINE_GROUP_DETAILS_URL_SUFFIX = '/api/web/admin/machinegroup/:id';
  private MACHINE_GROUP_URL_SUFFIX = '/api/web/admin/machinegroup';
  private MACHINE_GROUP_WITH_ID_URL_SUFFIX = '/api/web/admin/machinegroup/:id';
  private MACHINE_GROUP_IS_NAME_USED_URL_SUFFIX = '/api/web/admin/machinegroup/isMachineryGroupNameUsed?name=:name';

  private readonly BASE_URL: string;

  constructor(private http: HttpClient, private apiLocation: ApiLocationService) {
    this.BASE_URL = this.apiLocation.getLocation();
  }


  public addMachineryGroup(machineGroup: MachineGroup): Observable<any> {
    const url: string = this.BASE_URL + this.MACHINE_GROUP_URL_SUFFIX;

    const request = {
      machineryGroup: {
        name: machineGroup.name,
        parentName: machineGroup.parentName,
        parentId: machineGroup.parentId
      },
      assignedMachinesIds: this.getIdFromMachines(machineGroup.machines)
    };


    return this.http.post(url, request, HTTPS_REQUEST_OPTIONS);
  }

  public getMachineryGroupDetails(machineGroupId: number): Observable<any> {
    let url: string = this.BASE_URL + this.MACHINE_GROUP_DETAILS_URL_SUFFIX;
    url = url.replace(':id', String(machineGroupId));
    return new Observable<any>((observer: Subscriber<any>) => {
      this.http.get<MachineryGroupPayload>(url, HTTPS_REQUEST_OPTIONS).subscribe({
        next: (groupPayloadResponse: MachineryGroupPayload) => {
          const group: MachineGroup = groupPayloadResponse.machineryGroup;
          group.machines = [...groupPayloadResponse.assignedMachines];
          observer.next(group);
          observer.complete();
        }, error: err => {
          observer.error(err);
          observer.complete();
        }
      });
    });

  }

  public updateMachineryGroup(machineGroup: MachineGroup): Observable<any> {
    let url: string = this.BASE_URL + this.MACHINE_GROUP_WITH_ID_URL_SUFFIX;
    url = url.replace(':id', String(machineGroup.id));

    const request = {
      machineryGroup: {
        id: machineGroup.id,
        name: machineGroup.name,
        parentName: machineGroup.parentName,
        parentId: machineGroup.parentId,
        subMachineGroups: machineGroup.subMachineGroups,
        adminsGroup: machineGroup.adminsGroup,
        createdBy: machineGroup.createdBy,
        creationTime: machineGroup.creationTime,
        externalId: machineGroup.externalId,
        normalizedName: machineGroup.normalizedName
      },
      assignedMachinesIds: this.getIdFromMachines(machineGroup.machines)
    };
    return this.http.post(url, request, HTTPS_REQUEST_OPTIONS);
  }

  public delete(machineGroupId: number): Observable<any> {
    let url: string = this.BASE_URL + this.MACHINE_GROUP_WITH_ID_URL_SUFFIX;
    url = url.replace(':id', String(machineGroupId));

    return this.http.delete(url, HTTPS_REQUEST_OPTIONS);
  }

  public isNameUsed(name: string): Observable<boolean> {
    let url = this.BASE_URL + this.MACHINE_GROUP_IS_NAME_USED_URL_SUFFIX;
    url = url.replace(':name', name);
    return this.http.get<boolean[]>(url, HTTPS_REQUEST_OPTIONS).pipe(map(res => res[0]));
  }

  private getIdFromMachines(machines: Machine[]): number[] {
    const machinesById: number[] = new Array<number>();
    machines.forEach((element) => {
      if (element.id !== undefined) {
        machinesById.push(element.id);
      }
    });
    return machinesById;
  }
}
